import { getSVG } from './components/icons-loader.js';
import { slickSliderGenerator} from './components/sliders.js';
import { showMoreFaqs, accordion } from './components/accordion.js';

document.addEventListener("DOMContentLoaded", function () {
  slickSliderGenerator('testimonials', '.testimonials-container');
  accordion('.faqs-cards');
  showMoreFaqs();
  getSVG();
});
